import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { AddressRepository } from '../repositories/address.repository';
import { CountriesResponse } from '../models/countries-response.model';

export class GetCountriesUseCase implements UseCase<never, CountriesResponse> {
    constructor(private readonly repository: AddressRepository) {}

    execute(): Observable<CountriesResponse> {
        return this.repository.getCountries();
    }
}
